module.exports = __webpack_public_path__ + "static/img/vivoX50Pro.ad47aa1a.png";